import * as Yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum PickTicketLineItemKeys {
  lot = 'lot',
  sku = 'sku',
  description = 'description',
  supplier = 'supplier',
  unitOfMeasure = 'unitOfMeasure',
  qty = 'qty',
}

const PickTicketLineItemSchema = Yup.object().shape({
  [PickTicketLineItemKeys.lot]: Yup.string().nullable().optional(),
  [PickTicketLineItemKeys.sku]: Yup.string().nullable().optional(),
  [PickTicketLineItemKeys.description]: Yup.string().nullable().optional(),
  [PickTicketLineItemKeys.supplier]: Yup.string().nullable().optional(),
  [PickTicketLineItemKeys.unitOfMeasure]: Yup.string().nullable().optional(),
  [PickTicketLineItemKeys.qty]: Yup.string().nullable().optional(),
})

export const pickTicketFileDataSchema = Yup.object().shape({
  ticketTitle: Yup.string().nullable().optional(),
  ticketSubTitle: Yup.string().nullable().optional(),
  shipTo: Yup.object()
    .shape({
      companyName: Yup.string().nullable().optional(),
      projectDescription: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      addressLine2: Yup.string().nullable().optional(),
      cityStateZip: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
    })
    .required(),
  notes: Yup.string().nullable().optional(),
  transactionNumber: Yup.string().nullable().optional(),
  referenceNumber: Yup.string().nullable().optional(),
  vendorNumber: Yup.string().nullable().optional(),
  poNumber: Yup.string().nullable().optional(),
  enteredDate: Yup.string().nullable().optional(),
  earliestShipDate: Yup.string().nullable().optional(),
  cancelDate: Yup.string().nullable().optional(),
  carrier: Yup.string().nullable().optional(),
  service: Yup.string().nullable().optional(),
  billing: Yup.string().nullable().optional(),
  accountNumber: Yup.string().nullable().optional(),
  items: Yup.array().of(PickTicketLineItemSchema).required(),
})

export type PickTicketFileData = Yup.InferType<typeof pickTicketFileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<PickTicketFileData>

export const pickTicketFileMappings: RequiredFileData = {
  ticketTitle: '7efbfa76-bb71-4df6-adae-00a9f13ade94',
  ticketSubTitle: '02135372-7658-47f7-835b-8cc38e0a7a35',
  shipTo: {
    companyName: 'a1b2c3d4-5e6f-4a7b-8c9d-0e1f2a3b4c5d',
    projectDescription: 'b2c3d4e5-6f7a-4b8c-9d0e-1f2a3b4c5d6e',
    addressLine1: 'c3d4e5f6-7a8b-4c9d-0e1f-2a3b4c5d6e7f',
    addressLine2: 'd4e5f6a7-8b9c-4d0e-1f2a-3b4c5d6e7f8a',
    cityStateZip: 'e5f6a7b8-9c0d-4e1f-2a3b-4c5d6e7f8a9b',
    phoneNumber: 'f6a7b8c9-0d1e-4f2a-3b4c-5d6e7f8a9b0c',
  },
  notes: 'a7b8c9d0-1e2f-4a3b-4c5d-6e7f8a9b0c1d',
  transactionNumber: 'b8c9d0e1-2f3a-4b4c-5d6e-7f8a9b0c1d2e',
  referenceNumber: 'c9d0e1f2-3a4b-4c5d-6e7f-8a9b0c1d2e3f',
  vendorNumber: 'd0e1f2a3-4b5c-4d6e-7f8a-9b0c1d2e3f4a',
  poNumber: 'e1f2a3b4-5c6d-4e7f-8a9b-0c1d2e3f4a5b',
  enteredDate: 'f2a3b4c5-6d7e-4f8a-9b0c-1d2e3f4a5b6c',
  earliestShipDate: 'a3b4c5d6-7e8f-4a9b-0c1d-2e3f4a5b6c7d',
  cancelDate: 'b4c5d6e7-8f9a-4b0c-1d2e-3f4a5b6c7d8e',
  carrier: 'c5d6e7f8-9a0b-4c1d-2e3f-4a5b6c7d8e9f',
  service: 'd6e7f8a9-0b1c-4d2e-3f4a-5b6c7d8e9f0a',
  billing: 'e7f8a9b0-1c2d-4e3f-4a5b-6c7d8e9f0a1b',
  accountNumber: 'f8a9b0c1-2d3e-4f4a-5b6c-7d8e9f0a1b2c',
  items: [
    {
      lot: 'a9b0c1d2-3e4f-4a5b-6c7d-8e9f0a1b2c3d',
      sku: 'b0c1d2e3-4f5a-4b6c-7d8e-9f0a1b2c3d4e',
      description: 'c1d2e3f4-5a6b-4c7d-8e9f-0a1b2c3d4e5f',
      supplier: 'd2e3f4a5-6b7c-4d8e-9f0a-1b2c3d4e5f6a',
      unitOfMeasure: 'e3f4a5b6-7c8d-4e9f-0a1b-2c3d4e5f6a7b',
      qty: 'f4a5b6c7-8d9e-4f0a-1b2c-3d4e5f6a7b8c',
    },
  ],
}
